<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">期刊查找</h1>
                        <h2>為您的論文找到最合適的投稿期刊</h2>
                        <p>透過比對論文核心概念與數百萬筆出版資料與趨勢，Trinka 期刊查找工具協助您精準鎖定理想期刊，加速投稿流程。</p>
                        <div class="btn-group">
                            <a href="https://cloud.trinka.ai/signup?_rg=TW" class="filled-btn" target="_blank">開始使用</a>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <img src="/assets/images/features/journal-finder.webp" width="1080" height="976" alt="Journal Finder" class="img-fluid md50" style="width: 70%;" priority />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 bg-light">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>Trinka 期刊推薦工具，如何為您精準導航？</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <h3>更順暢的發表流程</h3>
                    <p>Trinka 結合最新 AI 技術，深入理解您的論文內容，並比對各大期刊的出版資料，推薦最合適的投稿期刊。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>有依據的投稿決策</h3>
                    <p>我們不只推薦期刊，還會顯示該期刊中與您主題相近的論文，幫助您判斷是否符合投稿範疇，做出更有信心的選擇。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>掠奪性期刊警示</h3>
                    <p>Trinka 的先進 AI 技術能識別並標示具有不道德出版行為的期刊，避免您不小心投稿至掠奪性出版商。</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="howItWorks section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="list-wrapper-image">
                    <a href="" data-toggle="modal" data-target="#youtubeModalPopup" id="VewiVideoSection">
                        <img src="/assets/images/yt-thumbnail/JournalFinderThumbnail.webp" width="600" height="338" alt="video thumbnail" class="img-fluid eposter-img">
                    </a>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="list-wrapper-content-2">
                    <div class="trinka-title mb-0">
                        <h2>觀看教學</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                        <p>立即觀看操作教學影片，快速上手「期刊查找」功能！</p>
                        <p>透過簡單的教學影片，讓你一步步學會如何使用 Trinka。</p>
                        <p class="mb-0">還有其他問題嗎？歡迎瀏覽我們的常<a style="color: #0000ff;" (click)="scroll(target)" class="link text-link">見問答</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="cloud_key_features section-pd list-wrapper-style-2 pb-0">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>Trinka 期刊查找工具的主要特色</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>快速找到適合您論文的期刊，並查看各期刊的相似論文，助您做出明智的投稿決策</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <img src="/assets/images/icons/AI-power.svg" width="40" height="40" alt="AI-Powered Journal Recommendations">
                    <h3>AI 智慧推薦</h3>
                    <p>採用最新 AI 技術，深入理解您的論文核心概念，精準匹配合適期刊推薦。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="/assets/images/icons/all-subjects.svg" width="40" height="40" alt="Works for all Subjects Areas">
                    <h3>涵蓋所有學科領域</h3>
                    <p>擁有豐富的科學論文資料庫，支援各學科領域的期刊推薦。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="/assets/images/icons/large-database.svg" width="40" height="40" alt="Large Database of Scientific Publications">
                    <h3 style="white-space: nowrap;">龐大科學出版資料庫</h3>
                    <p>利用來自 OpenAlex 等權威來源的海量科學出版資料，確保推薦準確。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="/assets/images/icons/publication-trend.svg" width="40" height="40" alt="Publication Trends to Understand Citability">
                    <h3>出版趨勢分析</h3>
                    <p>展示相關主題的發表趨勢，幫助您了解論文未來的曝光與引用潛力。</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="/assets/images/icons/similar.svg" width="40" height="40" alt="Similar Articles for Perfect Scope Match">
                    <h3>相似文章推薦，確保投稿範圍吻合</h3>
                    <p>顯示各推薦期刊中與您論文相似的文章，讓您確認投稿範圍吻合，避免遭編輯直接拒稿。</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="/assets/images/icons/search-intutive.svg" width="40" height="40" alt="Intuitive Filters for Refined Search">
                    <h3>直覺式篩選條件</h3>
                    <p>提供主題、開放取用、影響力指數等多種篩選條件，並支持自訂篩選，快速鎖定理想期刊。
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<app-security-section></app-security-section>

<section class="faqQuestionAnwser section-pd pt-0" #target>
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>常見問答</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Trinka 期刊查找有什麼不同？
                                    </a>
                                </div>

                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka 期刊查找採用先進的 AI 概念匹配技術，跨越多學科與出版物，協助您找到最適合您論文的投稿期刊。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        期刊查找是否僅限於開放取用期刊？</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>不是，Trinka 的資料庫涵蓋來自 Crossref、PubMed 等多種來源的論文，並不限於開放取用期刊。如果您只想查找開放取用期刊，也可以透過篩選條件來達成。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        我可以輸入自己想投稿的期刊嗎？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>可以，您可以輸入心儀的期刊名稱，期刊查找會幫您評估該期刊是否適合您的論文，並同時建議其他合適的期刊選擇。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-trinka-in-other-apps></app-trinka-in-other-apps>

<div class="modal" id="youtubeModalPopup">
    <div class="modal-dialog modal-dialog-centered modal-lg">
       <div class="modal-content">
          <div class="modal-body no-padding">
             <button type="button" class="btn-close" data-dismiss="modal" (click)="stopAllVideos()"></button>
             <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/fuWNwHYFPFM"
                title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
          </div>
       </div>
    </div>
</div>